import {forwardRef} from '@chakra-ui/react';
import type {AsyncSelectComponent, GroupBase, OptionBase, SelectComponentsConfig} from 'chakra-react-select';
import {AsyncSelect as BaseAsyncSelect, createFilter} from 'chakra-react-select';
import React from 'react';

import {useAvatarSelectStyleConfig} from '../../theme-config';

import {components as selectComponents} from './CustomSelect';

type CustomSelectComponent = AsyncSelectComponent;

export interface ApplicationOption extends OptionBase {
  avatar?: React.ReactElement<any> | string;
  value: string;
  label: string;
}
const {MenuList: _MenuList, ...rest} = selectComponents;

const components: SelectComponentsConfig<ApplicationOption, false, GroupBase<ApplicationOption>> = {
  ...rest,
};

// TODO: connect this implementation with the 'AvatarSelect' component
export const AsyncSelect: CustomSelectComponent = forwardRef((props, ref) => {
  const chakraStyles = useAvatarSelectStyleConfig(props);
  return (
    <BaseAsyncSelect
      {...props}
      chakraStyles={{
        indicatorSeparator: (provided, _state) => ({...provided, ...chakraStyles.indicatorSeparator}),
        indicatorsContainer: (provided, _state) => ({...provided, ...chakraStyles.indicatorsContainer}),
        dropdownIndicator: (provided, _state) => ({...provided, ...chakraStyles.dropdownIndicator}),
        control: (provided, _state) => ({...provided, ...chakraStyles.control}),
        downChevron: (provided, _state) => ({...provided, ...chakraStyles.downChevron}),
        valueContainer: (provided, _state) => ({...provided, ...chakraStyles.valueContainer}),
      }}
      ref={ref}
      size={`lg`}
      filterOption={props.filterOption ?? createFilter({ignoreAccents: false})}
      // @ts-expect-error chakra-react-select types not matching but functioning correctly
      components={props.components ?? components}
    />
  );
});
